import { Paper } from "@mui/material"
import { FC } from "react"

interface DateHeaderProps{
    prevDateString: string,
    dateString: string
}

export const DateHeader:FC<DateHeaderProps> = ({ prevDateString, dateString }) => {
    if(prevDateString == dateString){
        return null;
    }

    return <Paper elevation={6} sx={{ padding: 2, background:"#DDDDDD" }}><h3>{dateString}</h3></Paper>
}
